module.exports = __webpack_public_path__ + "background4.jpg?a623820294adaba201ef4151a0213780";